function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasetHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa000"
    },
    d: "M40 12H22l-4-4H8c-2.2 0-4 1.8-4 4v8h40v-4c0-2.2-1.8-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffca28"
    },
    d: "M40 12H8c-2.2 0-4 1.8-4 4v20c0 2.2 1.8 4 4 4h32c2.2 0 4-1.8 4-4V16c0-2.2-1.8-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.457945
    },
    d: "M15.258 25.89s3.69-5.057 8.245-5.057c4.553 0 8.24 5.057 8.24 5.057s-3.686 5.018-8.24 5.018c-4.555 0-8.245-5.018-8.245-5.018z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.457945
    },
    d: "M23.503 20.833c4.554 0 8.24 5.057 8.24 5.057s-3.686 5.018-8.24 5.018c-4.555 0-8.245-5.018-8.245-5.018s3.69-5.057 8.245-5.057m0-.915c-4.963 0-8.823 5.21-8.985 5.432l-.396.542.397.54c.163.22 4.023 5.392 8.984 5.392 4.96 0 8.817-5.172 8.978-5.392l.397-.54-.394-.542c-.162-.222-4.019-5.432-8.981-5.432z",
    fill: "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.457945,
      fill: "#b3e0e5",
      fillOpacity: 1
    },
    d: "M19.381 25.868a4.12 4.12 0 0 1 4.122-4.119 4.123 4.123 0 1 1-4.122 4.119z",
    fill: "#00acc1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.457945,
      fill: "#40babf",
      fillOpacity: 1
    },
    d: "M21.671 25.87a1.832 1.832 0 1 1 3.664 0 1.832 1.832 0 0 1-3.664 0z",
    fill: "#006064"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.457945
    },
    d: "M15.27 25.87c.24-.32 3.833-5.018 8.233-5.018 4.398 0 7.987 4.698 8.227 5.018H34l-.778-1.062c-.174-.237-4.299-5.788-9.72-5.788-5.42 0-9.549 5.55-9.722 5.787L13 25.87z",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.500005
    },
    fill: "#37474f",
    d: "M33.5 34.583 32.083 36 13.5 17.417 14.917 16Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetHidden);
export default __webpack_public_path__ + "static/media/datasetHidden.6460711ed0cc800130d61e0ed24ecee2.svg";
export { ForwardRef as ReactComponent };